module.exports = __webpack_public_path__ + "static/media/icn_careem_partner_logo.fa8604ba.svg";